<template>

      <ChatBody ref="chat" class="debug1" :width="width" :height="height">
        
        <template #messages>                              
          <ChatMessage v-for="(p, index) in messages" :key="index" :chatuser="user" :item="p" @reply="reply(p)">
            <template #delete><p class="deleteHover noselect" @click.prevent="deleteMessage(p)">×</p></template>          
          </ChatMessage>
        </template>

        <template #files>          
          <ChatFile v-for="(ff, findex) in files" :file="ff" :key="findex" @delete="tools.push(files,ff)" @click.prevent="showfile(ff)"/>                    
        </template>

        <template #reply>
          <ChatReply v-if="quote.id" :name="quote.name" :text="quote.text" @delete="deleteReply()"/>
        </template>

        <template #input>
          <ChatInput v-model="message.text" @send="send()">
            <template #left>
              <ChatIconUpload v-upload="appendFiles"/>
              <Switch v-model="sendAsUser" title="Send as user (ex: tests, etc)"/>
            </template>
            <template #right><ChatIconSend @click="send()"/></template>
          </ChatInput>
        </template>
      </ChatBody>

    <!-- asset preview -->
    <Teleport to="body">
      <Popup v-model="showFilePopup">
        <template #icon>
          <img style="max-height: 34px; width: auto;" :src="`/images/icons/file/${(tools.ext(file) || 'txt').toUpperCase()}.svg`">
        </template>
        <template #title>Attachment</template>
        <div class="column w400 left" style="padding: 20px 30px;">
          <p>{{ file.name }}</p>
        </div>
      </Popup>
    </Teleport>
  
  
</template>
<script setup>
import ChatBody from './ChatBody.vue';
import ChatFile from './ChatFile.vue';
import ChatIconSend from './ChatIconSend.vue';
import ChatIconUpload from './ChatIconUpload.vue';
import ChatInput from './ChatInput.vue';
import ChatMessage from './ChatMessage.vue';
import ChatReply from './ChatReply.vue';
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
// https://github.com/fritx/vue-at/tree/vue3#readme
export default defineComponent({
  mounted() {
      this.initChat()  
      this.getChat()    
  }, 
  props:{
    id: Number, //chat id    
    width: {type:String, default:'380px'},
    height: {type:String, default:'90vh'},
  }, 
  
  data() {
    return {    
      // asset: undefined, //uid/chat id
      chat:{},
      showFilePopup: false,
      showMentionsPopup: false,

      files:[],
      file: undefined,
      quote: {},

      message:{
        chat: this.id, 
        text: undefined, 
        reply: undefined,
        call: [],
        files: [],   
    	},
      

      progress: false,
      done: true,
      error: undefined,

      items: [],

      sendAsUser: false,

    }
  },
  computed: {
    messages(){
      let list = this.items || []
      if (!list.length) return []      
      let read = []
      list.forEach(p => {
        if (p.read || p.team) return        
        read.push(p.id)
      });
      if (read.length) this.chats.read(read)
      list = list.sort((a,b) => a.id < b.id);
      return list
    },
    
    uid(){
      let p = this.messages || []
      if (!p.length) return
      let last = p[0]
      if (!last) return
      return last.uid
    },
  
    // teamlist(){
    //   let team = this.db.supportTeam
    //   if (!team || !team.length) return []
    //   let list = []
    //   team.forEach(p => {
    //       list.push({id: p.id, name: p.name || 'no name', email: p.email, dept: p.dept})
    //   });      
    //   return list      
    // },
  },
  
  methods: {

    async initChat(){
      console.log('init chat', this.id)
      let id = Number(this.id)
      if (!id) return

      this.items = await this.chats.get(id, 50, 0)
      this.subscribe()
      
    },
    
    async getChat(){
      console.log('get chat', this.id)
      let id = Number(this.id)
      if (!id) return

      this.chat = await this.chats.chat(id)
      console.log('chat', this.chat)      
    },

    resetMessage(){   
      console.log('reset message')   
      this.message = {
        chat: this.id, 
        text: undefined, 
        reply: undefined,
        call: [],
        files: [],
    	}
    },

    subscribe(){
      let chat = this.id
      this.chats.subscribeChat(chat, this.inbox)  
      console.log("chat subscribe", chat)
    },

    inbox(data){
      console.log("inbox:",data)
      this.items.push(data)
      if (data.team) {
        this.$emit('message', true)
      }
    },


    async send(){
      this.progress = true

      let chat = this.id
      let text = this.message.text     
      let osfiles = this.files 
      let reply = 0            
      if (this.quote.id) reply = this.quote.id
      
      // send(chat, text, osfiles, reply)
      let res = await this.chats.send(chat, text, osfiles, reply, this.sendAsUser)
      if (res.error) {
        alert(res.error)
        console.error(res.error)
        this.progress = false
        return
      }

      this.files = []      
      this.quote = {}
      this.resetMessage()   
      this.resetTextarea()
      this.scrollToBottomChat()
      this.progress = false
    },
  

    // reset textarea
    resetTextarea(){
      let c = this.$refs.area      
      if (!c) return  
      c.setAttribute('style','background-color: #1C1C1C; width: 100%; margin: 0;padding-left: 0;padding-right: 0;');
      c.value = "";
      c.rows = "1"      
    },
   
    appendFiles(files){   
      console.log('new files', files)   
      this.files = this.files.concat(...files)
    },
    

    showfile(file){
      this.file = file
      this.showFilePopup = true      
    },

    async changeStatus(id, status){
      let res = await this.api.send('support/update/asset/status', {id, status})    
      if (res.error) return
      this.refreshAssets()
    },

    async refreshAssets(){
      let user = this.id
      let res = await this.api.send('support/assets', {user})
      if (res.error) return
      this.assets = res.resp.assets || []
    },

    mention(team){
      console.log('team', team)
      this.message.mention = team.id
      this.message.private = true
    },

    checkEmptyArea(){
      if (!this.message.text) {
        this.message.mention = undefined
        this.message.private = undefined
      }      
    },


    ctrlclick(message){
      console.log('ctrlclick',message)
    },

    async deleteMessage(message){      
      console.log('delete/message', message)
      if (!message) return
      let id = message.id      
      if (isNaN(id)) return
      console.log('message deleting', message)
      let res = await this.api.send('support/delete', {id})
      if (res.error) {
        console.log('message delete error', res.error)
        return
      }

      this.ws.deleteMessage(this.id, id)
      console.log('message deleted', id)
      // this.messages.splice(index, 1)
    },

    reply(msg){      
      let p = this.tools.clone(msg) 
      p.quote = undefined      
      this.quote = p        
    },

    deleteReply(){
      this.quote = undefined      
    },

    at(anchorLink) {
        let el = this.$refs[anchorLink]
        el.scrollIntoView({ behavior: 'smooth'})
    },
    
    scrollToMessage(id) {
      console.log('scrollToMessage', id)
        let el = this.$refs[`msg${id}`]
        el.scrollIntoView()
    },

    scrollToBottomChat() {      
        let el = this.$refs.chat
        el.scrollTop = 0;
    },
    
    
  },
});

</script>
<style scoped>
</style>